const getSchemaObj = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://hotmart.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target:
        'https://hotmart.com/s?q={search_term_string}&sck=HOTMART_SITE&src=GOOGLE_SEARCH',
      'query-input': 'required name=search_term_string',
    },
  }

  return schema
}

export default {
  getSchemaObj,
}
